import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from 'flarum/forum/app';
import Page from 'flarum/common/components/Page';
import Link from 'flarum/common/components/Link';
import Button from 'flarum/common/components/Button';
import Switch from 'flarum/common/components/Switch';
export default class TaldezainaSecurityQuestionsPage extends Page {
  constructor() {
    super(...arguments);
    _defineProperty(this, "questions", []);
    _defineProperty(this, "loading", true);
    _defineProperty(this, "saving", false);
    _defineProperty(this, "enabled", true);
    // Tabs state
    _defineProperty(this, "activeTab", 'questions');
    // Domain blocklist state
    _defineProperty(this, "loadingDomains", false);
    _defineProperty(this, "savingDomains", false);
    _defineProperty(this, "defaultBlockedDomains", []);
    _defineProperty(this, "customBlockedDomains", []);
    _defineProperty(this, "newDomainInput", '');
    _defineProperty(this, "showDefaultDomains", false);
    // Form state for creating / editing questions
    _defineProperty(this, "editingId", null);
    _defineProperty(this, "formQuestionEs", '');
    _defineProperty(this, "formQuestionEu", '');
    _defineProperty(this, "formAnswersList", []);
    _defineProperty(this, "newAnswerText", '');
    _defineProperty(this, "formIsActive", true);
    _defineProperty(this, "showModalForm", false);
  }
  oninit(vnode) {
    super.oninit(vnode);
    const canManage = !!(app.forum.attribute('canManagePlayers') || app.session.user && (app.session.user.attribute('canManagePlayers') || app.session.user.isAdmin()));
    if (!canManage) {
      m.route.set('/');
      return;
    }
    this.enabled = app.forum.attribute('nagusiSecurityQuestionsEnabled') !== false;
    this.loadQuestions();
    this.loadBlockedDomains();
  }
  loadQuestions() {
    this.loading = true;
    m.redraw();
    app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + '/nagusi/security-questions'
    }).then(res => {
      this.questions = res && res.data ? res.data : [];
      this.loading = false;
      m.redraw();
    }).catch(err => {
      console.error(err);
      this.loading = false;
      app.alerts.show({
        type: 'error'
      }, 'Error al cargar las preguntas de seguridad.');
      m.redraw();
    });
  }
  loadBlockedDomains() {
    this.loadingDomains = true;
    m.redraw();
    app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + '/nagusi/security/blocked-domains'
    }).then(res => {
      this.defaultBlockedDomains = res && res.default_domains ? res.default_domains : [];
      this.customBlockedDomains = res && res.custom_domains ? res.custom_domains : [];
      this.loadingDomains = false;
      m.redraw();
    }).catch(err => {
      console.error(err);
      this.loadingDomains = false;
      m.redraw();
    });
  }
  toggleModule(value) {
    this.enabled = value;
    m.redraw();
    app.request({
      method: 'POST',
      url: app.forum.attribute('apiUrl') + '/nagusi/security-questions/toggle-enabled',
      body: {
        enabled: value
      }
    }).then(() => {
      app.alerts.show({
        type: 'success'
      }, value ? 'Preguntas de seguridad activadas.' : 'Preguntas de seguridad desactivadas.');
    }).catch(err => {
      console.error(err);
      app.alerts.show({
        type: 'error'
      }, 'No se pudo guardar la configuración.');
    });
  }
  addAnswer() {
    const text = this.newAnswerText.trim();
    if (!text) return;

    // If user pasted or entered values with commas, split them
    const parts = text.split(',').map(s => s.trim()).filter(Boolean);
    for (const part of parts) {
      if (!this.formAnswersList.some(a => a.toLowerCase() === part.toLowerCase())) {
        this.formAnswersList.push(part);
      }
    }
    this.newAnswerText = '';
    m.redraw();
  }
  removeAnswer(index) {
    this.formAnswersList.splice(index, 1);
    m.redraw();
  }
  openCreate() {
    this.editingId = null;
    this.formQuestionEs = '';
    this.formQuestionEu = '';
    this.formAnswersList = [];
    this.newAnswerText = '';
    this.formIsActive = true;
    this.showModalForm = true;
  }
  openEdit(item) {
    const attrs = item.attributes || {};
    this.editingId = parseInt(item.id, 10);
    this.formQuestionEs = attrs.question_es || '';
    this.formQuestionEu = attrs.question_eu || '';
    const rawAnswers = attrs.answers || '';
    this.formAnswersList = rawAnswers ? rawAnswers.split(',').map(s => s.trim()).filter(Boolean) : [];
    this.newAnswerText = '';
    this.formIsActive = attrs.is_active !== false;
    this.showModalForm = true;
  }
  closeModal() {
    this.showModalForm = false;
    this.editingId = null;
  }
  saveQuestion(e) {
    e.preventDefault();

    // Add any remaining text in the answer input field
    this.addAnswer();
    const cleanAnswers = this.formAnswersList.map(s => s.trim()).filter(Boolean).join(',');
    if (!this.formQuestionEs.trim() || !this.formQuestionEu.trim() || !cleanAnswers) {
      app.alerts.show({
        type: 'error'
      }, 'Por favor, completa la pregunta en castellano, en euskera y añade al menos una respuesta.');
      return;
    }
    this.saving = true;
    m.redraw();
    const body = {
      data: {
        attributes: {
          question_es: this.formQuestionEs.trim(),
          question_eu: this.formQuestionEu.trim(),
          answers: cleanAnswers,
          is_active: this.formIsActive
        }
      }
    };
    const isEdit = !!this.editingId;
    const method = isEdit ? 'PATCH' : 'POST';
    const url = app.forum.attribute('apiUrl') + '/nagusi/security-questions' + (isEdit ? "/".concat(this.editingId) : '');
    app.request({
      method,
      url,
      body
    }).then(() => {
      app.alerts.show({
        type: 'success'
      }, isEdit ? 'Pregunta actualizada.' : 'Pregunta añadida.');
      this.closeModal();
      this.loadQuestions();
    }).catch(err => {
      console.error(err);
      app.alerts.show({
        type: 'error'
      }, 'Error al guardar la pregunta.');
    }).finally(() => {
      this.saving = false;
      m.redraw();
    });
  }
  deleteQuestion(id) {
    if (!confirm('¿Estás seguro de que deseas eliminar esta pregunta de seguridad?')) {
      return;
    }
    app.request({
      method: 'DELETE',
      url: app.forum.attribute('apiUrl') + "/nagusi/security-questions/".concat(id)
    }).then(() => {
      app.alerts.show({
        type: 'success'
      }, 'Pregunta eliminada.');
      this.loadQuestions();
    }).catch(err => {
      console.error(err);
      app.alerts.show({
        type: 'error'
      }, 'No se pudo eliminar la pregunta.');
    });
  }
  toggleQuestionActive(item) {
    const id = parseInt(item.id, 10);
    const currentActive = item.attributes ? item.attributes.is_active : true;
    const newActive = !currentActive;
    app.request({
      method: 'PATCH',
      url: app.forum.attribute('apiUrl') + "/nagusi/security-questions/".concat(id),
      body: {
        data: {
          attributes: {
            is_active: newActive
          }
        }
      }
    }).then(() => {
      if (item.attributes) item.attributes.is_active = newActive;
      m.redraw();
    }).catch(err => {
      console.error(err);
      app.alerts.show({
        type: 'error'
      }, 'Error al actualizar el estado.');
    });
  }
  addCustomDomain() {
    const text = this.newDomainInput.trim().toLowerCase();
    if (!text) return;
    const parts = text.split(/[\s,]+/).map(s => s.trim()).filter(s => s.includes('.'));
    for (const part of parts) {
      if (!this.customBlockedDomains.includes(part)) {
        this.customBlockedDomains.push(part);
      }
    }
    this.newDomainInput = '';
    m.redraw();
  }
  removeCustomDomain(index) {
    this.customBlockedDomains.splice(index, 1);
    m.redraw();
  }
  saveBlockedDomains() {
    this.addCustomDomain();
    this.savingDomains = true;
    m.redraw();
    app.request({
      method: 'POST',
      url: app.forum.attribute('apiUrl') + '/nagusi/security/blocked-domains',
      body: {
        domains: this.customBlockedDomains
      }
    }).then(res => {
      if (res && res.custom_domains) {
        this.customBlockedDomains = res.custom_domains;
      }
      app.alerts.show({
        type: 'success'
      }, 'Lista de dominios bloqueados guardada correctamente.');
    }).catch(err => {
      console.error(err);
      app.alerts.show({
        type: 'error'
      }, 'Error al guardar la lista de dominios.');
    }).finally(() => {
      this.savingDomains = false;
      m.redraw();
    });
  }
  view() {
    return m("div", {
      className: "TaldezainaSecurityQuestionsPage"
    }, m("div", {
      className: "container",
      style: "padding-top: 40px; padding-bottom: 60px; max-width: 1050px;"
    }, m("div", {
      style: "display: flex; justify-content: space-between; align-items: center; margin-bottom: 30px;"
    }, m(Link, {
      href: "/taldezaina",
      className: "Button Button--secondary",
      style: "display: inline-flex; align-items: center; gap: 8px; font-weight: bold; border-radius: 8px; padding: 10px 16px;"
    }, m("i", {
      className: "fas fa-arrow-left"
    }), "Volver a Taldezainak"), this.activeTab === 'questions' && m(Button, {
      className: "Button Button--primary",
      icon: "fas fa-plus",
      onclick: () => this.openCreate(),
      style: "font-weight: bold; border-radius: 8px; padding: 10px 18px;"
    }, "Nueva Pregunta")), m("div", {
      style: "background: rgba(255, 255, 255, 0.05); border: 1px solid rgba(255, 255, 255, 0.1); border-radius: 16px; padding: 25px 30px; margin-bottom: 25px; backdrop-filter: blur(8px);"
    }, m("div", {
      style: "display: flex; justify-content: space-between; align-items: center; flex-wrap: wrap; gap: 20px;"
    }, m("div", null, m("h1", {
      style: "font-size: 2em; font-weight: 800; margin: 0; color: var(--heading-color); display: flex; align-items: center; gap: 12px;"
    }, m("span", null, "\uD83D\uDEE1\uFE0F"), "Seguridad y Blindaje Anti-Spam"), m("p", {
      style: "color: var(--muted-color); font-size: 1.1em; margin: 8px 0 0 0; line-height: 1.5; max-width: 650px;"
    }, "Protecci\xF3n integral del registro: preguntas de verificaci\xF3n humana, validaci\xF3n DNS de servidores de correo (MX) y lista negra de dominios temporales.")), m("div", {
      style: "display: flex; align-items: center; gap: 15px; background: rgba(0,0,0,0.2); padding: 12px 20px; border-radius: 12px; border: 1px solid rgba(255,255,255,0.05);"
    }, m("span", {
      style: "font-weight: bold; font-size: 1.05em;"
    }, this.enabled ? 'Preguntas Activas' : 'Preguntas Pausadas'), Switch.component({
      state: this.enabled,
      onchange: val => this.toggleModule(val)
    })))), m("div", {
      style: "display: flex; gap: 10px; margin-bottom: 25px; border-bottom: 1px solid rgba(255, 255, 255, 0.1); padding-bottom: 12px;"
    }, m("button", {
      type: "button",
      className: "Button ".concat(this.activeTab === 'questions' ? 'Button--primary' : 'Button--secondary'),
      onclick: () => this.activeTab = 'questions',
      style: "font-weight: 700; border-radius: 8px; padding: 10px 18px; display: inline-flex; align-items: center; gap: 8px;"
    }, m("i", {
      className: "fas fa-question-circle"
    }), "Preguntas de Seguridad (", this.questions.length, ")"), m("button", {
      type: "button",
      className: "Button ".concat(this.activeTab === 'domains' ? 'Button--primary' : 'Button--secondary'),
      onclick: () => this.activeTab = 'domains',
      style: "font-weight: 700; border-radius: 8px; padding: 10px 18px; display: inline-flex; align-items: center; gap: 8px;"
    }, m("i", {
      className: "fas fa-ban"
    }), "Bloqueo de Emails y Dominios (", this.customBlockedDomains.length, " personalizados)")), this.activeTab === 'questions' && m("div", null, this.loading ? m("div", {
      style: "text-align: center; padding: 50px; color: var(--muted-color);"
    }, m("i", {
      className: "fas fa-spinner fa-spin fa-2x"
    }), m("p", {
      style: "margin-top: 15px;"
    }, "Cargando preguntas de seguridad...")) : this.questions.length === 0 ? m("div", {
      style: "text-align: center; padding: 60px 20px; background: rgba(255, 255, 255, 0.02); border: 2px dashed rgba(255, 255, 255, 0.1); border-radius: 16px;"
    }, m("div", {
      style: "font-size: 3.5rem; margin-bottom: 15px;"
    }, "\u2753"), m("h3", {
      style: "font-size: 1.4em; font-weight: 700; margin-bottom: 8px;"
    }, "No hay preguntas de seguridad"), m("p", {
      style: "color: var(--muted-color); max-width: 500px; margin: 0 auto 25px auto;"
    }, "A\xF1ade pares de preguntas en castellano y euskera con sus respuestas v\xE1lidas para blindar el registro frente a bots."), m(Button, {
      className: "Button Button--primary",
      onclick: () => this.openCreate()
    }, "Crear primera pregunta")) : m("div", {
      style: "display: flex; flex-direction: column; gap: 16px;"
    }, this.questions.map((item, idx) => {
      const attrs = item.attributes || {};
      const id = parseInt(item.id, 10);
      const isActive = attrs.is_active !== false;
      return m("div", {
        key: id,
        style: "background: rgba(255, 255, 255, 0.04); border: 1px solid ".concat(isActive ? 'rgba(255, 255, 255, 0.12)' : 'rgba(255, 255, 255, 0.04)', "; border-radius: 14px; padding: 22px 26px; display: flex; justify-content: space-between; align-items: flex-start; gap: 20px; opacity: ").concat(isActive ? '1' : '0.55', "; transition: border-color 0.2s;")
      }, m("div", {
        style: "flex: 1;"
      }, m("div", {
        style: "display: flex; align-items: center; gap: 10px; margin-bottom: 10px;"
      }, m("span", {
        style: "font-size: 0.85em; font-weight: 800; background: var(--primary-color); color: #fff; padding: 2px 10px; border-radius: 20px;"
      }, "#", idx + 1), m("span", {
        style: "font-size: 0.85em; font-weight: 700; padding: 2px 8px; border-radius: 6px; ".concat(isActive ? 'background: rgba(40, 167, 69, 0.2); color: #4cd964;' : 'background: rgba(255, 255, 255, 0.1); color: var(--muted-color);')
      }, isActive ? 'Activa' : 'Pausada')), m("div", {
        style: "margin-bottom: 12px;"
      }, m("div", {
        style: "font-weight: 700; font-size: 1.15em; color: var(--heading-color); margin-bottom: 4px; display: flex; align-items: baseline; gap: 8px;"
      }, m("span", {
        style: "font-size: 0.8em; opacity: 0.7; font-weight: 800;"
      }, "[ES]"), m("span", null, attrs.question_es)), m("div", {
        style: "font-weight: 600; font-size: 1.05em; color: var(--muted-color); display: flex; align-items: baseline; gap: 8px;"
      }, m("span", {
        style: "font-size: 0.8em; opacity: 0.7; font-weight: 800;"
      }, "[EU]"), m("span", null, attrs.question_eu))), m("div", {
        style: "background: rgba(0, 0, 0, 0.25); border-radius: 10px; padding: 10px 14px; font-size: 0.95em; display: flex; flex-wrap: wrap; align-items: center; gap: 8px;"
      }, m("span", {
        style: "font-weight: 700; color: var(--muted-color); margin-right: 4px; display: inline-flex; align-items: center; gap: 6px;"
      }, m("i", {
        className: "fas fa-key"
      }), "Respuestas v\xE1lidas:"), (attrs.answers ? attrs.answers.split(',').map(s => s.trim()).filter(Boolean) : []).map((ans, i) => m("span", {
        key: i,
        style: "display: inline-flex; align-items: center; background: rgba(255, 255, 255, 0.08); border: 1px solid rgba(255, 255, 255, 0.12); padding: 3px 10px; border-radius: 14px; font-size: 0.9em; font-weight: 600; color: #fff;"
      }, ans)))), m("div", {
        style: "display: flex; gap: 8px; align-items: center; align-self: center;"
      }, m(Button, {
        className: "Button ".concat(isActive ? 'Button--secondary' : 'Button--primary'),
        icon: isActive ? 'fas fa-pause' : 'fas fa-play',
        title: isActive ? 'Pausar pregunta' : 'Activar pregunta',
        onclick: () => this.toggleQuestionActive(item)
      }), m(Button, {
        className: "Button Button--secondary",
        icon: "fas fa-edit",
        title: "Editar",
        onclick: () => this.openEdit(item)
      }), m(Button, {
        className: "Button Button--danger",
        icon: "fas fa-trash-alt",
        title: "Eliminar",
        onclick: () => this.deleteQuestion(id)
      })));
    }))), this.activeTab === 'domains' && m("div", {
      style: "display: flex; flex-direction: column; gap: 24px;"
    }, m("div", {
      style: "background: rgba(56, 189, 248, 0.08); border: 1px solid rgba(56, 189, 248, 0.25); border-radius: 14px; padding: 20px 24px;"
    }, m("div", {
      style: "display: flex; align-items: flex-start; gap: 14px;"
    }, m("i", {
      className: "fas fa-shield-alt",
      style: "font-size: 1.5em; color: #38bdf8; margin-top: 2px;"
    }), m("div", null, m("h3", {
      style: "font-size: 1.15em; font-weight: 700; margin: 0 0 6px 0; color: #38bdf8;"
    }, "Validaci\xF3n DNS MX y Lista Negra Activas en Tiempo Real"), m("p", {
      style: "margin: 0; color: var(--muted-color); line-height: 1.5; font-size: 0.95em;"
    }, "Cada registro nuevo se somete autom\xE1ticamente a una comprobaci\xF3n DNS de registros MX para verificar que su dominio existe y admite correo. Adem\xE1s, se rechaza cualquier direcci\xF3n que pertenezca a proveedores de correo temporal/desechable o a la lista personalizada de abajo.")))), m("div", {
      style: "background: rgba(255, 255, 255, 0.04); border: 1px solid rgba(255, 255, 255, 0.1); border-radius: 16px; padding: 26px 30px;"
    }, m("h2", {
      style: "font-size: 1.3em; font-weight: 800; margin: 0 0 8px 0; color: var(--heading-color); display: flex; align-items: center; gap: 10px;"
    }, m("i", {
      className: "fas fa-envelope-open-text",
      style: "color: #f87171;"
    }), "Dominios Personalizados Vetados"), m("p", {
      style: "color: var(--muted-color); font-size: 0.95em; margin: 0 0 18px 0;"
    }, "A\xF1ade dominios sospechosos para impedir altas con ellos (ej. ", m("code", null, "spammer.xyz"), " o ", m("code", null, "correo-basura.com"), "). Los subdominios quedar\xE1n bloqueados autom\xE1ticamente."), m("div", {
      style: "display: flex; gap: 10px; margin-bottom: 16px; max-width: 600px;"
    }, m("input", {
      type: "text",
      className: "FormControl",
      placeholder: "Ej: spammer.xyz (pulsa Enter para a\xF1adir)",
      value: this.newDomainInput,
      oninput: e => this.newDomainInput = e.target.value,
      onkeydown: e => {
        if (e.key === 'Enter') {
          e.preventDefault();
          this.addCustomDomain();
        }
      },
      style: "flex: 1; border-radius: 8px; border: 1px solid rgba(255,255,255,0.15); padding: 10px 14px;"
    }), m(Button, {
      type: "button",
      className: "Button Button--primary",
      onclick: () => this.addCustomDomain(),
      style: "border-radius: 8px; display: inline-flex; align-items: center; gap: 6px; font-weight: bold; padding: 0 18px;"
    }, m("i", {
      className: "fas fa-plus"
    }), " A\xF1adir")), m("div", {
      style: "min-height: 50px; padding: 14px; background: rgba(0,0,0,0.25); border: 1px solid rgba(255,255,255,0.08); border-radius: 12px; margin-bottom: 20px;"
    }, this.customBlockedDomains.length === 0 ? m("span", {
      style: "color: var(--muted-color); font-style: italic; font-size: 0.95em;"
    }, "No hay dominios personalizados vetados todav\xEDa.") : m("div", {
      style: "display: flex; flex-wrap: wrap; gap: 8px;"
    }, this.customBlockedDomains.map((dom, idx) => m("span", {
      key: idx,
      style: "display: inline-flex; align-items: center; gap: 8px; background: rgba(239, 68, 68, 0.15); border: 1px solid rgba(239, 68, 68, 0.35); padding: 5px 12px; border-radius: 20px; font-size: 0.95em; font-weight: 600; color: #fca5a5;"
    }, m("span", null, "@", dom), m("button", {
      type: "button",
      onclick: () => this.removeCustomDomain(idx),
      style: "border: none; background: none; color: #fca5a5; cursor: pointer; padding: 0 2px; font-size: 1.1em; line-height: 1;",
      title: "Eliminar dominio"
    }, "\xD7"))))), m(Button, {
      type: "button",
      className: "Button Button--primary",
      loading: this.savingDomains,
      onclick: () => this.saveBlockedDomains(),
      style: "font-weight: 700; border-radius: 8px; padding: 10px 22px;"
    }, "Guardar lista de dominios")), m("div", {
      style: "background: rgba(255, 255, 255, 0.02); border: 1px solid rgba(255, 255, 255, 0.08); border-radius: 14px; padding: 20px 24px;"
    }, m("div", {
      style: "display: flex; justify-content: space-between; align-items: center; cursor: pointer;",
      onclick: () => this.showDefaultDomains = !this.showDefaultDomains
    }, m("div", {
      style: "display: flex; align-items: center; gap: 10px;"
    }, m("i", {
      className: "fas fa-list-ul",
      style: "color: var(--muted-color);"
    }), m("span", {
      style: "font-weight: 700; font-size: 1.05em; color: var(--heading-color);"
    }, "Lista base de dominios temporales protegidos por defecto (", this.defaultBlockedDomains.length, " servicios)")), m("i", {
      className: "fas fa-chevron-".concat(this.showDefaultDomains ? 'up' : 'down'),
      style: "color: var(--muted-color);"
    })), this.showDefaultDomains && m("div", {
      style: "margin-top: 18px; padding-top: 16px; border-top: 1px solid rgba(255, 255, 255, 0.06);"
    }, m("p", {
      style: "color: var(--muted-color); font-size: 0.9em; margin: 0 0 12px 0;"
    }, "Estos dominios est\xE1n incluidos directamente en el n\xFAcleo de la extensi\xF3n y son bloqueados autom\xE1ticamente sin necesidad de a\xF1adirlos manualmente:"), m("div", {
      style: "display: flex; flex-wrap: wrap; gap: 6px; max-height: 220px; overflow-y: auto; padding-right: 5px;"
    }, this.defaultBlockedDomains.map((dom, i) => m("span", {
      key: i,
      style: "background: rgba(255, 255, 255, 0.05); border: 1px solid rgba(255, 255, 255, 0.08); padding: 3px 9px; border-radius: 12px; font-size: 0.85em; color: var(--muted-color);"
    }, "@", dom)))))), this.showModalForm && m("div", {
      style: "position: fixed; top: 0; left: 0; right: 0; bottom: 0; background: rgba(0,0,0,0.7); display: flex; align-items: center; justify-content: center; z-index: 1050; padding: 20px;",
      onclick: e => {
        if (e.target === e.currentTarget) this.closeModal();
      }
    }, m("div", {
      style: "background: var(--body-bg, #1a1e24); border: 1px solid rgba(255,255,255,0.15); border-radius: 16px; padding: 30px; max-width: 650px; width: 100%; box-shadow: 0 20px 50px rgba(0,0,0,0.5);"
    }, m("h3", {
      style: "margin: 0 0 20px 0; font-size: 1.5em; font-weight: 800; color: var(--heading-color); display: flex; align-items: center; gap: 10px;"
    }, m("i", {
      className: this.editingId ? 'fas fa-edit' : 'fas fa-plus-circle'
    }), this.editingId ? 'Editar Pregunta de Seguridad' : 'Nueva Pregunta de Seguridad'), m("form", {
      onsubmit: e => this.saveQuestion(e)
    }, m("div", {
      className: "Form-group",
      style: "margin-bottom: 18px;"
    }, m("label", {
      style: "font-weight: 700; margin-bottom: 6px; display: block;"
    }, "Pregunta en Castellano *"), m("input", {
      type: "text",
      className: "FormControl",
      placeholder: "Ej: \xBFC\xF3mo se llama el estadio del Athletic Club?",
      value: this.formQuestionEs,
      oninput: e => this.formQuestionEs = e.target.value,
      required: true
    })), m("div", {
      className: "Form-group",
      style: "margin-bottom: 18px;"
    }, m("label", {
      style: "font-weight: 700; margin-bottom: 6px; display: block;"
    }, "Pregunta en Euskera *"), m("input", {
      type: "text",
      className: "FormControl",
      placeholder: "Ej: Nola du izena Athletic Cluben estadioak?",
      value: this.formQuestionEu,
      oninput: e => this.formQuestionEu = e.target.value,
      required: true
    })), m("div", {
      className: "Form-group",
      style: "margin-bottom: 18px;"
    }, m("label", {
      style: "font-weight: 700; margin-bottom: 4px; display: block;"
    }, "Respuestas v\xE1lidas *"), m("p", {
      className: "helpText",
      style: "margin: 0 0 10px 0; font-size: 0.9em; color: var(--muted-color);"
    }, "Escribe una respuesta y pulsa Enter o \"+ A\xF1adir\". Puedes meter todas las variantes que admitas."), m("div", {
      style: "display: flex; gap: 10px; margin-bottom: 12px;"
    }, m("input", {
      type: "text",
      className: "FormControl",
      placeholder: "Ej: San Mam\xE9s (pulsa Enter para a\xF1adir)",
      value: this.newAnswerText,
      oninput: e => this.newAnswerText = e.target.value,
      onkeydown: e => {
        if (e.key === 'Enter') {
          e.preventDefault();
          this.addAnswer();
        }
      },
      style: "flex: 1; border-radius: 8px; border: 1px solid rgba(255,255,255,0.12); padding: 9px 14px;"
    }), m(Button, {
      type: "button",
      className: "Button Button--primary",
      onclick: () => this.addAnswer(),
      style: "border-radius: 8px; display: inline-flex; align-items: center; gap: 6px; font-weight: bold; padding: 0 16px;"
    }, m("i", {
      className: "fas fa-plus"
    }), " A\xF1adir")), m("div", {
      style: "display: flex; flex-wrap: wrap; gap: 8px; min-height: 42px; padding: 10px; background: rgba(0,0,0,0.2); border: 1px solid rgba(255,255,255,0.08); border-radius: 10px; align-items: center;"
    }, this.formAnswersList.map((ans, idx) => m("span", {
      key: idx,
      style: "display: inline-flex; align-items: center; gap: 8px; background: rgba(255, 255, 255, 0.1); border: 1px solid rgba(255, 255, 255, 0.15); padding: 5px 12px; border-radius: 20px; font-size: 0.95em; font-weight: 600; color: #fff;"
    }, m("span", null, ans), m("button", {
      type: "button",
      onclick: () => this.removeAnswer(idx),
      style: "border: none; background: none; color: var(--muted-color); cursor: pointer; padding: 0 2px; font-size: 1.1em; line-height: 1; transition: color 0.15s ease;",
      onmouseenter: e => e.target.style.color = '#f87171',
      onmouseleave: e => e.target.style.color = 'var(--muted-color)',
      title: "Eliminar respuesta"
    }, "\xD7"))), this.formAnswersList.length === 0 && m("span", {
      style: "color: var(--muted-color); font-style: italic; font-size: 0.9em;"
    }, "A\xFAn no has a\xF1adido respuestas para esta pregunta."))), m("div", {
      className: "Form-group",
      style: "margin-bottom: 25px;"
    }, m("label", {
      className: "checkbox",
      style: "display: flex; align-items: center; gap: 8px; cursor: pointer;"
    }, m("input", {
      type: "checkbox",
      checked: this.formIsActive,
      onchange: e => this.formIsActive = e.target.checked
    }), m("span", {
      style: "font-weight: 600;"
    }, "Pregunta activa (aparecer\xE1 en el registro)"))), m("div", {
      style: "display: flex; justify-content: flex-end; gap: 12px;"
    }, m(Button, {
      type: "button",
      className: "Button",
      onclick: () => this.closeModal()
    }, "Cancelar"), m(Button, {
      type: "submit",
      className: "Button Button--primary",
      loading: this.saving
    }, this.editingId ? 'Guardar Cambios' : 'Crear Pregunta')))))));
  }
}
flarum.reg.add('nagusi-match-ratings', 'forum/lineup/TaldezainaSecurityQuestionsPage', TaldezainaSecurityQuestionsPage);